import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';
import { UserSettings } from './usersettings';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
var moment = require('moment');
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { CommonFunction } from '../main/CommonFunction';
import { Subscription } from 'rxjs';
import { CustomDateFormat } from './CustomDateFormat';
import { DatePipe } from '@angular/common';
import { CommonReportService } from '../shared/services/CommonReportService.service';
@Component({
    selector: 'vendor-ledger-template',
    template: require('./CommonVendorLedgerTemplate.html'),
    styles: [``]
})
export class CommonVendorLedgerTemplateComponent implements OnInit {
    @Input('vendorname') Vendor_Name: any;
    @Input('name') Name: any;
    @Input('vendorid') Vendor_ID: any;
    @Input("dValue") dvalue: any;
    @ViewChild('payreciptpopup') payreciptpopup: ElementRef;
    @ViewChild('accountpostingpopup') accountpostingpopup: ElementRef;

    static parameters = [UtilityService, HttpClient, NgbModal, HotkeysService, BsDatepickerConfig, CommonFunction, CustomDateFormat, DatePipe, CommonReportService]
    bsConfig: any;
    busy: Subscription;
    public overlayNoRowsTemplate: any;
    toastWarningMsg(msg) {
        this.toast({ type: 'warning', title: msg });
    }
    constructor(public utilityService: UtilityService, public http: HttpClient, private modalService: NgbModal, private hotkeysService: HotkeysService, public _bsDatepickerConfig: BsDatepickerConfig, public commonFunction: CommonFunction, public customDateFormat: CustomDateFormat, public datePipe: DatePipe, public commonReportService: CommonReportService) {
        this.http = http;
        this.modalService = modalService;
        this.hotkeysService = hotkeysService;
        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        this.bsConfig = Object.assign({}, { dateInputFormat: this.unitInfo.dateInputFormat, containerClass: this.unitInfo.dateColorTheme });
        this._bsDatepickerConfig.dateInputFormat = this.unitInfo.dateInputFormat;
        //   console.log("this.bsConfig", this.bsConfig);

        this.defaultColDef = {
            resizable: true
        };

        $(document).ready(function () {
            // var position = $('vendor-ledger-template .modal-body .table-responsive').offset();
            var header = $('vendor-ledger-template .modal-header').height();
            var body = $('vendor-ledger-template').parent().height();
            // document.getElementsByTagName('vendor-ledger-template');
            var appHeight = body - header + 'px !important';
            $('vendor-ledger-template .modal-body .table-responsive.ledger').attr('style', 'height:' + appHeight);
        })
    }

    gridColumnApiVendorLedger: any;
    gridApiVendorLedger: any;
    paginationConf: any;
    d: any;
    defaultColDef: any;
    rowSelectionSingle: string;
    searchValue: any;
    unitInfo: any;
    modalReference: NgbModalRef;
    public overlayLoadingTemplate: any;
    public hotkeyList: Hotkey[];
    toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        // backdrop: `rgba(30, 30, 37, 0.4)`
    });

    ngOnInit(): void {
        //   console.log('Common Vendor Ledger Template init!');
        this.rowSelectionSingle = "single";
        this.d = this.dvalue;
        this.overlayNoRowsTemplate = "<h4> No record to show. </h4>";
        this.paginationConf = UserSettings.enablePagination;
        this.vendorLedgercolumnDefs = [
            { headerName: 'Doc Type', field: 'DocType_Desc', width: 100 },
            { headerName: 'Doc No', field: 'TransNo', width: 100 },
            {
                headerName: 'Date', field: 'Doc_Date', width: 105,
                cellRenderer: (data) => {
                    return data.value ? moment(data.value).format(this.unitInfo.dateInputFormat) : "";
                }
            },
            { headerName: 'Bill No', field: 'Bill_No', width: 150 },
            { headerName: 'Bill Date', field: 'Bill_Date', width: 105 },
            { headerName: 'Status', field: 'Status', width: 70 },
            { headerName: 'Remarks', field: 'Remarks', width: 200 },
            { headerName: 'Debit', field: 'Debit', width: 120, cellStyle: { textAlign: 'right' } },
            { headerName: 'Credit', field: 'Credit', width: 120, cellStyle: { textAlign: 'right' } },
            {
                headerName: 'Balance', field: 'balance', width: 120, cellStyle: { textAlign: 'right' }
                , cellRenderer: (data) => {
                    return data.value < 0 ? Math.abs(data.value) : data.value;
                }
            },
            {
                headerName: '', field: 'balance', width: 40, cellRenderer: (data) => {
                    return data.data.FI_ID > 0 ? data.value < 0 ? 'CR' : 'DR' : '';
                }
            },
            { headerName: 'Reco Date', field: 'RecoDate', width: 100, cellStyle: { color: 'red' } },
            { headerName: 'Adj Doc No.', field: 'AD_DocNo', hide:true },
            { headerName: 'Adj Doc Date', field: 'Ad_DocDate', hide:true },
            { headerName: 'Adj. Amt', field: 'Ad_Amt', hide:true }
        ];
        this.initHotkeys();
        this.initModalQuery('.page-search');
        setTimeout(() => {
            $("#From_Date").focus();
        }, 200);
        this.ledgerSearch.From_Date = this.oneMonthAgo();
        this.ledgerSearch.To_Date = new Date();
        this.vendorLedgermain();
        this.vendorLedgerRowData = [];
        this.overlayLoadingTemplate = "<div class='loader2'>" +
            "<div class='loading'><img src='public/loader-icon-2.svg'></div>" +
            "</div>";
    }

    initHotkeys() {
        this.hotkeyList = [];

        let ctrlo = new Hotkey('alt+o', (event: KeyboardEvent): boolean => {
            $('vendor-ledger-template #okbtn').trigger('click');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrlo);
        this.hotkeysService.add(ctrlo);

        let ctrle = new Hotkey('alt+e', (event: KeyboardEvent): boolean => {
            $('vendor-ledger-template #excelbtn').trigger('click');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrle);
        this.hotkeysService.add(ctrle);

        const ctrlf = new Hotkey('ctrl+f', (event: KeyboardEvent): boolean => {
            $("vendor-ledger-template #filter-text-box1").focus();
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrlf);
        this.hotkeysService.add(ctrlf);

        let alta = new Hotkey('alt+a', (event: KeyboardEvent): boolean => {
            $('vendor-ledger-template #payment-details').trigger('click');
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alta);
        this.hotkeysService.add(alta);
    }

    ngAfterViewInit() {
        this.paginationConf = UserSettings.enablePagination;
    }

    initModalQuery(className) {
        var parent = this;
        // let jqueryclass = className + ' ul.form-group';
        $(className).on('keydown', 'input, select, textarea, input[role=combobox]', function (e) {
            // console.log("enter");
            var self = $(this)
                , form = self.parents(className + ':eq(0)')
                , focusable
                , next
                ;
            if (e.keyCode == 13) {
                // focusable = form.find('input:not([type="radio"]), input:enabled, a, select, button, textarea, input[role=combobox]').filter(':visible');
                focusable = form.find('input:not([type="radio"]), input[role=combobox]').filter(':visible');
                next = focusable.eq(focusable.index(this) + 1);

                if (this.classList.contains('custom-date')) {
                    parent.customDateFormat.GetCustomDateFormat(this, parent.datePipe);
                }
                if (next.length) {
                    next.focus().select();
                } else {
                    $('#okbtn1').focus();
                    // $(id).focus();
                    //form.submit();
                    //parent.addCompany();
                }
                return false;
            }
        });
    }

    f_chkString(p_value) {
        var Val = (p_value ? p_value.toString() : "").trim();
        return Val;
    }

    f_chkNum(p_value) {
        var Val = Number(p_value);
        if (Val) {
            return Val;
        }
        return 0;
    }

    ledgerSearch: any = {};
    vendorLedgerRowData: any;
    vendorLedgercolumnDefs: any;
    ledgerrowData_DocType: any;
    vendorLedgermain() {
        if (isNaN(Date.parse(this.ledgerSearch.From_Date))) {
            this.toastWarningMsg("Invalid From Date!");
            $("#From_Date").focus();
            return false;
        }
        if (isNaN(Date.parse(this.ledgerSearch.To_Date))) {
            this.toastWarningMsg("Invalid To Date!");
            $("#To_Date").focus();
            return false;
        }
        if (Date.parse(this.ledgerSearch.To_Date) < Date.parse(this.ledgerSearch.From_Date)) {
            this.toastWarningMsg("From date can not be greater than to date!");
            return false;
        }

        let To_Date = moment(this.ledgerSearch.To_Date).format('YYYY-MM-DD');
        let From_Date = moment(this.ledgerSearch.From_Date).format('YYYY-MM-DD');
        var data = {
            "Vendor_ID": this.Vendor_ID,
            "Unit_ID": this.unitInfo.Unit_ID,
            "Company_ID": this.unitInfo.Company_ID,
            "From_Date": From_Date,
            "To_Date": To_Date,
            "DocType_Desc": this.f_chkNum(this.ledgerSearch.Transaction_Type)
        };
        this.busy = this.http.post('/api/vendors/Get_Ledger_Vendor_Wise', data)
            .subscribe((response: any) => {
                this.vendorLedgerRowData = response.ledgerData;
                let TopRow = {}, BottomRow = {};
                let OP = this.f_chkNum(response.ledgerFooterData.length > 0 ? response.ledgerFooterData[0].OpeningBalance : 0);
                this.vendorLedgerRowData.forEach((element, index, array) => {
                    let OpeningBalance = this.f_chkNum((index == 0) ? OP : array[index - 1].balance);
                    element["balance"] = ((this.f_chkNum(element.Debit) - this.f_chkNum(element.Credit)) + OpeningBalance).toFixed(2);
                });
                setTimeout(() => {
                    if (OP < 0) {
                        TopRow = { "Remarks": "Opening Balance", "Debit": '', "Credit": (OP < 0 ? OP * -1 : OP).toFixed(2) };
                    } else {
                        TopRow = { "Remarks": "Opening Balance", "Debit": OP.toFixed(2), "Credit": '' };
                    }
                    let CB = this.vendorLedgerRowData.length > 0 ? this.f_chkNum(this.vendorLedgerRowData[this.vendorLedgerRowData.length - 1]['balance']) : OP;
                    if (CB < 0) {
                        BottomRow = { "Remarks": "Closing Balance", "Debit": '', "Credit": (CB < 0 ? CB * -1 : CB).toFixed(2) };
                    } else {
                        BottomRow = { "Remarks": "Closing Balance", "Debit": CB.toFixed(2), "Credit": '' };
                    }
                    let self = this;
                    let TotalRow = this.vendorLedgerRowData.length;
                    let TotalDebit = (this.vendorLedgerRowData.reduce(function (acc, sum) {
                        return acc + (self.f_chkNum(sum.Debit));
                    }, 0)).toFixed(2);
                    let TotalCredit = (this.vendorLedgerRowData.reduce(function (acc, sum) {
                        return acc + (self.f_chkNum(sum.Credit));
                    }, 0)).toFixed(2);
                    let BottomTotal = { "DocType_Desc": "Total Count : ", "TransNo": TotalRow, "Bill_No": "Total :", "Debit": TotalDebit, "Credit": TotalCredit };
                    this.gridApiVendorLedger.setPinnedTopRowData([TopRow]);
                    this.gridApiVendorLedger.setPinnedBottomRowData([BottomRow, BottomTotal]);
                }, 200);
                this.ledgerrowData_DocType = this.findUnique(response.ledgerData, d => d.DocType_Desc)
                setTimeout(() => {
                    if (this.vendorLedgerRowData.length > 0) {
                        this.gridApiVendorLedger.getModel().getRow(0).setSelected(true);
                    }
                    this.gridApiVendorLedger.sizeColumnsToFit();
                }, 300);
            })
    }

    findUnique(arr, predicate) {
        var found = {};
        arr.forEach(d => {
            found[predicate(d)] = d;
        });
        return Object.keys(found).map(key => found[key]);
    }

    VendorLedgerGridReady(params) {
        this.gridApiVendorLedger = params.api;
        this.gridColumnApiVendorLedger = params.columnApi;
        setTimeout(() => {
            this.gridApiVendorLedger.sizeColumnsToFit();
        }, 300);
    }

    oneMonthAgo() {
        var monthAgo = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            new Date().getDate()
        );
        return monthAgo;
    }

    exportExcelVendorLedger() {
        let To_Date = moment(this.ledgerSearch.To_Date).format('DD-MMM-YYYY');
        let From_Date = moment(this.ledgerSearch.From_Date).format('DD-MMM-YYYY');
        let row = this.unitInfo.Company_Name + '\n' + this.unitInfo.Company_Full_Address + '\n' + this.Name + ' Name :' + this.Vendor_Name + '\n' + 'From : ' + From_Date + ',' + 'To : ' + To_Date;
        let d = new Date();
        var fName = this.Name + 'Ledger_' + d.getTime();
        var params = {
            columnGroups: true,
            skipFooters: false,
            allColumns: true,
            customHeader: row,
            fileName: fName,
        };
        this.gridApiVendorLedger.exportDataAsCsv(params);
    }

    ledgerRowSelected: any = [];
    LedgerTransType: any;
    ledgeronSelectionChanged() {
        var selectedRows = this.gridApiVendorLedger.getSelectedRows();
        this.ledgerRowSelected = selectedRows[0];
        this.LedgerTransType = "";
        if (selectedRows.length > 0) {
            this.LedgerTransType = this.f_chkNum(selectedRows[0].Transaction_Type);
        }
    }

    VendorLedgerNavigateScreen(event) {
        let parent = this;
        if (event.keyCode == 13 || event.type == "rowDoubleClicked") {
            let focusedCell = this.gridApiVendorLedger.getFocusedCell();
            if (focusedCell && focusedCell.column["colDef"]["field"] == "TransNo") {
                let selectedRows = this.gridApiVendorLedger.getSelectedRows();
                //   console.log("Naivgation Data :::: ", selectedRows);
                let TransNo = this.f_chkNum(selectedRows[0].Transaction_No);
                let TransType = this.f_chkNum(selectedRows[0].Transaction_Type);
                let Doc_Date = selectedRows[0].Doc_Date;
                if (TransNo > 0) {
                    let data_navi = { "ScreenType": TransType, "Transaction_No": TransNo, "Transaction_Date": Doc_Date }
                    parent.commonFunction.Nevigate_Document_Entry(data_navi);
                }
            }
        }
    }

    onPopupFilterTextBoxChanged(e) {
        let value = $('input#filter-text-box1').val();
        this.gridApiVendorLedger.setQuickFilter(value);
    }

    venHandleKeyDown(event) {
        if (event.which == 13) {
            this.gridApiVendorLedger.setFocusedCell(0, "DocType_Desc");
        }
    }

    OpenPayReceiptPopup() {
        setTimeout(() => {
            this.modalService.open(this.payreciptpopup, { size: 'sm', windowClass: 'data-show ledger' });
        }, 200);
    }

    OpenAccountPostingtPopup() {
        setTimeout(() => {
            this.modalService.open(this.accountpostingpopup, { size: 'lg', windowClass: 'data-show width75 accountposting updateWarehouseWidth', backdropClass: 'productPop' });
        }, 200);
    }

    printLedger() {
        var data = {
            "FileName": "rptVendorLedger"
            , "FormatType": "pdf"
            , "params": {
                FromDate: moment(this.ledgerSearch.From_Date).format('YYYY-MM-DD'),
                ToDate: moment(this.ledgerSearch.To_Date).format('YYYY-MM-DD'),
                Vendor_ID: this.Vendor_ID,
                DocType_Desc: this.f_chkNum(this.ledgerSearch.Transaction_Type)
            }
        };

        this.busy = this.commonReportService.GetJasperReport(data).subscribe(response => {
            var filename = '';
            if (response) {
                var error = '';
                error = response["error"];
                filename = response["FilePath"];
                if (filename.length > 0) {
                    window.open(filename, '_blank');
                }
            }
        });
    }
}

